<template>

  <div>
    <el-card class="mb20 mt20 ml20 mr20 ta-l">
      <div class="flex-center-between">
        <div class="flex-center">
          <img class="mr20 image-user" src="@/assets/user/image-user.png" alt/>
          <div class="info-area fz14">
            <div class="lh25">{{ userInfo.deptList[0]?.deptName.split('|')[0] }}</div>
            <div class="lh25 fc9">{{ userInfo.deptList[0]?.orgCode }}</div>
          </div>
        </div>
        <div class="flex-column">
          <div>您还可以制作 {{ userInfo.makeCount }} 枚印章</div>
          <div class="fz12 fc9 mt5">(首次登录后赠送两次测试制作次数)</div>
        </div>
      </div>
    </el-card>

    <div class="mb20 ml20 mr20 mt20 flex-r-between">
      <div class="home-section" style="width: calc(50% - 10px)">
        <el-card shadow="hover" style="border-radius: 8px; overflow: hidden;">
          <template #header>
            <div class="flex-center-between">
              <h3 style="margin: 0; font-weight: 600; color: #303133;">产品展示</h3>
            </div>
          </template>
          <el-carousel arrow="hover" indicator-position="outside"
                       style="height: 400px; border-radius: 4px; overflow: hidden;">
            <el-carousel-item v-for="(item, index) in leftShowList" :key="index"
                              style="display: flex;justify-content: center; align-items: center;">
              <el-image
                  style="width: 100%; height: 100%;"
                  fit="contain"
                  :src="item"
                  :preview-src-list="leftShowList"
                  :lazy="true"
              ></el-image>
            </el-carousel-item>
          </el-carousel>
        </el-card>

      </div>

      <div class="home-section" style="width: calc(50% - 10px)">
        <el-card shadow="hover" style="border-radius: 8px;">
          <template #header>
            <div class="flex-center-between">
              <h3 style="margin: 0; font-weight: 600; color: #303133;">软件下载</h3>
            </div>
          </template>
          <el-descriptions :column="1" style="margin-top: 10px;">
            <el-descriptions-item label="排版软件" align="left">
              <a
                  href="https://www.lngsyz.com/app/广烁印章排版系统.msi"
                  download
                  style="color: #409EFF; text-decoration: none;"
              >
                立即下载
              </a>
            </el-descriptions-item>
            <el-descriptions-item label="使用手册" align="left">
              <a
                  href="https://www.lngsyz.com/app/排版软件使用说明.pdf"
                  download
                  style="color: #409EFF; text-decoration: none;"
              >
                立即下载
              </a>
            </el-descriptions-item>
            <el-descriptions-item label="使用视频" align="left">
              <a
                  href="https://www.lngsyz.com/app/排版软件操作视频.mp4"
                  download
                  style="color: #409EFF; text-decoration: none;"
              >
                立即下载
              </a>
            </el-descriptions-item>
            <el-descriptions-item label="ukey中间件" align="left">
              <a
                  href="https://www.lngsyz.com/app/ukey中间件.zip"
                  download
                  style="color: #409EFF; text-decoration: none;"
              >
                立即下载
              </a>
            </el-descriptions-item>
            <el-descriptions-item label="签章客户端" align="left">
              <a
                  href="https://www.lngsyz.com/app/oes/client-oes.exe"
                  download
                  style="color: #409EFF; text-decoration: none;"
              >
                立即下载
              </a>
            </el-descriptions-item>
          </el-descriptions>
        </el-card>
        <!--        <el-card shadow="hover" style="border-radius: 8px; height: 100%;">-->
        <!--          <template #header>-->
        <!--            <div class="flex-center-between">-->
        <!--              <h3 style="margin: 0; font-weight: 600; color: #303133;">新闻动态</h3>-->
        <!--            </div>-->
        <!--          </template>-->
        <!--          <el-carousel arrow="hover" height="560px" indicator-position="outside" style="border-radius: 4px; overflow: hidden;">-->
        <!--            <el-carousel-item>-->
        <!--              <div class="news-item">-->
        <!--                <el-image -->
        <!--                  style="width: 100%; height: 200px; border-radius: 4px; margin-bottom: 15px;" -->
        <!--                  fit="cover" -->
        <!--                  src="https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg"-->
        <!--                ></el-image>-->
        <!--                <h4 style="margin: 0 0 10px 0; font-weight: 600; color: #303133;">印章系统新版本发布</h4>-->
        <!--                <p style="margin: 0; color: #606266; line-height: 1.5;">-->
        <!--                  广烁印章排版系统V3.0版本正式发布，新增多项功能，提升用户体验，支持更多印章类型的制作。-->
        <!--                </p>-->
        <!--                <div style="margin-top: 15px; color: #909399; font-size: 12px;">-->
        <!--                  发布时间：2026-01-01-->
        <!--                </div>-->
        <!--              </div>-->
        <!--            </el-carousel-item>-->
        <!--            <el-carousel-item>-->
        <!--              <div class="news-item">-->
        <!--                <el-image -->
        <!--                  style="width: 100%; height: 200px; border-radius: 4px; margin-bottom: 15px;" -->
        <!--                  fit="cover" -->
        <!--                  src="https://cube.elemecdn.com/9/c2/f0ee8a3c7c9638a54940382568c9dpng.png"-->
        <!--                ></el-image>-->
        <!--                <h4 style="margin: 0 0 10px 0; font-weight: 600; color: #303133;">安全认证升级</h4>-->
        <!--                <p style="margin: 0; color: #606266; line-height: 1.5;">-->
        <!--                  系统通过国家信息安全等级保护认证，为企业印章管理提供更安全可靠的保障。-->
        <!--                </p>-->
        <!--                <div style="margin-top: 15px; color: #909399; font-size: 12px;">-->
        <!--                  发布时间：2025-12-15-->
        <!--                </div>-->
        <!--              </div>-->
        <!--            </el-carousel-item>-->
        <!--            <el-carousel-item>-->
        <!--              <div class="news-item">-->
        <!--                <el-image -->
        <!--                  style="width: 100%; height: 200px; border-radius: 4px; margin-bottom: 15px;" -->
        <!--                  fit="cover" -->
        <!--                  src="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png"-->
        <!--                ></el-image>-->
        <!--                <h4 style="margin: 0 0 10px 0; font-weight: 600; color: #303133;">操作指南更新</h4>-->
        <!--                <p style="margin: 0; color: #606266; line-height: 1.5;">-->
        <!--                  最新版操作指南已发布，详细介绍了系统各项功能的使用方法和常见问题解决方案。-->
        <!--                </p>-->
        <!--                <div style="margin-top: 15px; color: #909399; font-size: 12px;">-->
        <!--                  发布时间：2025-11-30-->
        <!--                </div>-->
        <!--              </div>-->
        <!--            </el-carousel-item>-->
        <!--          </el-carousel>-->
        <!--        </el-card>-->
      </div>
    </div>


  </div>

</template>

<script>

import Cookie from "js-cookie";

export default {
  name: "home",
  data() {
    return {
      userInfo: {
        deptList: []
      },
      leftShowList: [
        require('@/assets/customerEnterprise/poster.png'),
        require('@/assets/customerEnterprise/pic1.png'),
        require('@/assets/customerEnterprise/pic2.png'),
      ]
    }
  },
  created() {
    this.getInfo()
  },
  methods: {
    getInfo() {
      this.$http.get(this.$api.customerEnterprise.getInfo).then(res => {
        //判断登录类型是个人还是企业，用户账户信息中基本信息的展示
        this.userInfo = res.data.data.kqUserInfo
        this.$auth.setKqUserId(res.data.data.kqUserInfo.userId);
        Cookie.set("orgCode", res.data.data.kqUserInfo.deptList[0]?.orgCode);
        // Cookie.set("agency", res.data.data.kqUserInfo.deptList[0]?.agency);
      })
    },
  }
}
</script>

<style scoped lang="less">
::v-deep .el-carousel__container {
  height: 400px;
}

.flex-column {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.fz12 {
  font-size: 12px;
}

.fc9 {
  color: #909399;
}

.mt5 {
  margin-top: 5px;
}

.home-section {
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
  }
}

::v-deep .el-card {
  transition: all 0.3s ease;

  &:hover {
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  }
}

::v-deep .el-button {
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3);
  }
}

.news-item {
  padding: 10px;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
  }
}

::v-deep .el-descriptions__border .el-descriptions__cell {
  padding: 12px 10px;
}

::v-deep .el-carousel__indicator.is-active button {
  background-color: #409EFF;
}
</style>
